import { adminSections } from './adminSections';

export const adminManual = {
  id: 'mod-admin',
  title: 'Administrador del sistema',
  isVisible: (ctx) => ctx.isAdmin,
  intro:
    'Configuración global: módulos, parámetros generales, integraciones y usuarios. Solo rol administrador; cada pantalla con documentación de 12 apartados.',
  sections: adminSections,
};
